import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Beranda', href: '/' },
    { name: 'Produk', href: '/products' },
    { name: 'Pelanggan', href: '/customers' },
    { name: 'Kontak', href: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.6, 0.05, 0.01, 0.9] }}
      className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800/50"
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <motion.img
              src="/vamos-logo.png"
              alt="Vamos Digital Solusi"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="h-20 md:h-24 w-auto brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-500"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="relative group"
              >
                <span className={`text-sm font-medium transition-colors ${
                  isActive(item.href) ? 'text-emerald-400' : 'text-slate-300 hover:text-white'
                }`}>
                  {item.name}
                </span>
                {isActive(item.href) && (
                  <motion.div
                    layoutId="navbar-indicator"
                    className="absolute -bottom-6 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-500 to-blue-500"
                  />
                )}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <motion.a
              href="https://service.whatap.io/account/create?_gl=1*t6k6li*_gcl_au*MTQ4NjMyMjgwMS4xNzg0MTY5MzY5*_ga*MjU1MDA5NDI4LjE3NjE3OTgyNzI.*_ga_MR3V3MJVJ2*czE3ODQxNjkzNjkkbzExJGcxJHQxNzg0MTY5Mzg3JGo0MiRsMCRoMA..*_ga_NR722KYGXH*czE3ODQxNjkzNjkkbzExJGcwJHQxNzg0MTY5MzY5JGo2MCRsMCRoMA.."
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white rounded-full font-semibold text-sm flex items-center gap-2 shadow-lg shadow-emerald-500/25"
            >
              Coba Gratis
              <ChevronRight className="w-4 h-4" />
            </motion.a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white p-2"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <motion.div
        initial={false}
        animate={{ height: isOpen ? 'auto' : 0 }}
        className="md:hidden overflow-hidden bg-slate-900/95 backdrop-blur-xl border-b border-slate-800"
      >
        <div className="container mx-auto px-6 py-6 space-y-4">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={() => setIsOpen(false)}
              className={`block py-2 text-lg font-medium transition-colors ${
                isActive(item.href) ? 'text-emerald-400' : 'text-slate-300 hover:text-white'
              }`}
            >
              {item.name}
            </Link>
          ))}
          <a
            href="https://service.whatap.io/account/create?_gl=1*t6k6li*_gcl_au*MTQ4NjMyMjgwMS4xNzg0MTY5MzY5*_ga*MjU1MDA5NDI4LjE3NjE3OTgyNzI.*_ga_MR3V3MJVJ2*czE3ODQxNjkzNjkkbzExJGcxJHQxNzg0MTY5Mzg3JGo0MiRsMCRoMA..*_ga_NR722KYGXH*czE3ODQxNjkzNjkkbzExJGcwJHQxNzg0MTY5MzY5JGo2MCRsMCRoMA.."
            target="_blank"
            rel="noopener noreferrer"
            className="w-full px-6 py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white rounded-full font-semibold text-center block"
          >
            Coba Gratis
          </a>
        </div>
      </motion.div>
    </motion.nav>
  );
};

export default Navbar;
